import React, { useContext, useEffect, useState } from 'react'
import imgIcon from "../../assets";
import { Buttons } from "../../common/Buttons";
import { IconDetalis } from "../../common/IconDetalis";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { LeftRightlayout } from "../Container/LeftRightlayout";
import { buttonClass, Icon } from "../../common/CSS";
import { Header } from "../Container/Header";
import { useSelector } from "react-redux";
import moment from "moment";
import FormContextApi from "../../ContextApi";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Loader from "../../common/Loder";
import { gtag } from 'ga-gtag';

export function GetEngineer() {
    const { setaccess, ticketdata } = useContext(FormContextApi);
    const { ticketCreated, viewTicket } = useSelector((store) => store.ticketsreducer);
    const { wallet_applicable } = useSelector((store) => store.userreducer);
    const { viweTicketLoading } = useSelector((store) => store.loadingreducer);
    const navigator = useNavigate();
    const [date, setDate] = useState('');
    if (ticketCreated === undefined) {
        navigator('/service');
    }
    const fileName = () => {
        let fileName = ticketdata?.file;
        let p = [];
        for (let i = 0; i < fileName.length; i++) {
            p.push(<p className='mt-2 text-16F text-scogoOrange'>{fileName[i].name}</p>);
        }
        return p;
    };

    useEffect(() => {
        document.title = 'Get Engineer';
    }, []);

    const onClickHandler = () => {
        gtag('event', 'Click', {
            'chat-with-engineer': 'button',
        });
        window.open(`${config.ui4Domain}/chat`, '_blank');
    };

    useEffect(() => {
        setaccess({ pageacces: true, paymentacces: true, gstModal: 'stop' });
    }, []);

    useEffect(() => {
        if (ticketCreated) {
            const formattedDate = moment(ticketCreated?.execution_date).format('dddd D, MMMM YYYY');
            setDate(formattedDate);
        }
    }, [ticketCreated]);

    let clutername = `${viewTicket?.cl_details?.first_name === undefined ? 'Scogo' : viewTicket?.cl_details?.first_name} ${
        viewTicket?.cl_details?.last_name === undefined ? '' : viewTicket?.cl_details?.last_name
    }`;

    const Content = () => {
        return (
            <>
                <Header showButton path='/Done' />

                <div>
                    <div className={`${Icon.HeadingIcon} ${wallet_applicable && 'grid-cols-3'}`}>
                        <IconDetalis coloreIcon='text-darkblue' IconName='manage_accounts' IconHeading='Your Details' />
                        <IconDetalis coloreIcon='text-darkblue' IconName='devices' IconHeading='Select Service' />
                        {!wallet_applicable && <IconDetalis coloreIcon='text-darkblue' IconName='currency_rupee' IconHeading='Payment' />}
                        <IconDetalis coloreIcon='text-darkblue' IconName='engineering' IconHeading='Get Engineer' />
                        <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBox'>
                            <CheckCircleIcon />
                        </div>
                        <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBox'>
                            <CheckCircleIcon />
                        </div>
                        {!wallet_applicable && (
                            <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBox'>
                                <CheckCircleIcon />
                            </div>
                        )}
                        <div className='w-full rounded-none bg-darkblue h-3P mt-3 checkBox'>
                            <CheckCircleIcon />
                        </div>
                    </div>
                </div>

                <div className='hidden getEneginerContainer m-auto mt-4 '>
                    <div className='m-auto text-center p-6 w-full bg-white shadow-subBtnShadow border border-whiBlue rounded-sm'>
                        <h1 className='font-bold text-xl'>Assigned Scogo Manager</h1>
                        {viweTicketLoading ? (
                            <div className='mt-28 mb-24'>
                                <Loader speed='1' thickness='6' size='50' />
                            </div>
                        ) : (
                            <div>
                                <div className='mt-4 w-44 m-auto'>
                                    <img width='80%' className='m-auto' src={imgIcon.Enginerpic} alt='' />
                                </div>
                                <h1 className=' mt-4 text-22F'>
                                    {viewTicket?.cl_details?.first_name} {viewTicket?.cl_details?.last_name}
                                </h1>

                                <p className='text-scogoprimary mt-4 text-base'>{viewTicket?.cl_details?.mobile}</p>
                                <p className='text-scogoprimary mt-1 text-base'>{viewTicket?.cl_details?.email}</p>

                                <p className='text-stardust mt-1 text-base'>
                                    City: <span className='text-scogoprimary'>{viewTicket?.job_city?.city_name}</span>{' '}
                                </p>
                                <p className='text-stardust mt-1 text-base'>
                                    State: <span className='text-scogoprimary'>{viewTicket?.job_state?.state_name}</span>{' '}
                                </p>
                                <div className='mt-7'>
                                    <Buttons
                                        btnText={`Chat with ${clutername}`}
                                        onClick={() => {
                                            onClickHandler();
                                        }}
                                        classN={'bg-scogoprimary shadow-subBtnShadow border border-scogoprimary rounded-md p-2 text-white w-full text-base'}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className='w-11/12 p-2 m-auto mt-4'>
                    <h1 className='text-22F mt-4 font-medium flex justify-between'>
                        Scogo Ticket Details
                        <img
                            className='hidden googlePlayStore'
                            src={imgIcon.Google}
                            alt=''
                            onClick={() => {
                                window.open('https://play.google.com/store/apps/details?id=com.scogo.scogonetworks&hl=en_IN&gl=US', '_blank');
                            }}
                        />
                    </h1>
                    <div className='mt-4'>
                        <div className='mt-2'>
                            <p className='text-stardust text-base'> Ticket Number</p>
                            <p className='text-16F mt-1'>{ticketCreated?.job_ticket_number}</p>
                        </div>
                        <div className='mt-4'>
                            <p className='text-stardust text-base'> Service Location</p>
                            <p className='text-16F mt-1 w-4/5'>{ticketCreated?.job_pickup_address_1}</p>
                        </div>
                        <div className='mt-4'>
                            <p className='text-stardust text-base'> Service Description</p>
                            <p className='text-16F mt-1'>{ticketCreated?.description}</p>
                        </div>
                        {date !== 'Invalid date' && (
                            <div className='mt-4'>
                                <p className='text-stardust text-base'>Service Date</p>
                                <p className='text-16F mt-1'>{date}</p>
                            </div>
                        )}
                        {ticketdata?.file && (
                            <div className='mt-4'>
                                <p className='text-stardust text-base'>Service Document</p>
                                {ticketdata?.file && fileName()}
                            </div>
                        )}
                    </div>
                </div>

                <div className='w-full m-auto absolute text-center mt-8 pb-4' role='button'>
                    <Buttons
                        btnText='Go to Portal'
                        classN={`${buttonClass?.scogoPrimary} w-43% mr-6 pt-2 pb-2 `}
                        Iconafter={
                            <Tooltip title={<div className='text-17F'>Invite users or create bulk Tickets</div>} placement='top-start' className='Tooltip' arrow>
                                <IconButton>
                                    <HelpOutlineIcon className='text-white text-1rem' />
                                </IconButton>
                            </Tooltip>
                        }
                        onClick={() => {
                            gtag('event', 'Click', {
                                portal: 'button',
                            });
                            window.open(config?.portal, '_blank');
                        }}
                    />
                    <Buttons
                        btnText='Book New Ticket '
                        classN={`${buttonClass?.scogoOrange} w-43%  rounded-md pt-2 pb-2 `}
                        onClick={() => {
                            navigator('/service');
                        }}
                    />
                </div>
            </>
        );
    };

    const rightSection = () => {
        return (
            <>
                <div className='m-auto w-68P mt-48'>
                    <div className='m-auto mt-28 text-center p-6 w-467P bg-white shadow-subBtnShadow border border-whiBlue rounded-sm'>
                        <h1 className='font-bold text-xl'>Assigned Scogo Manager</h1>

                        <div className='mt-4 w-44 m-auto '>
                            <img width={'100%'} src={imgIcon.Enginerpic} alt='' />
                        </div>
                        <h1 className=' mt-4 text-22F'>
                            {viewTicket?.cl_details?.first_name} {viewTicket?.cl_details?.last_name}
                        </h1>

                        <p className='text-scogoprimary mt-4 text-base'>{viewTicket?.cl_details?.mobile}</p>
                        <p className='text-scogoprimary mt-1 text-base'>{viewTicket?.cl_details?.email}</p>

                        <p className='text-stardust mt-1 text-base'>
                            City: <span className='text-scogoprimary'>{viewTicket?.job_city?.city_name}</span>{' '}
                        </p>
                        <p className='text-stardust mt-1 text-base'>
                            State: <span className='text-scogoprimary'>{viewTicket?.job_state?.state_name}</span>{' '}
                        </p>
                        <div className='mt-7'>
                            <Buttons
                                btnText={`Chat With ${clutername}`}
                                onClick={() => {
                                    onClickHandler();
                                }}
                                classN={'bg-scogoprimary shadow-subBtnShadow border border-scogoprimary rounded-sm p-2 text-white w-full text-base'}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return <LeftRightlayout Content={Content} RightImg={rightSection} />;
}
